import { makeStyles } from '@mui/styles';
// colors
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  root: {
    borderRadius: 8,
    boxShadow: `0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)`,
    backgroundColor: colors.white,
    border: `1px solid ${colors.neutral100}`,
    padding: 16,
    height: 96,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '4px',
  },
  value: {
    margin: 0,
    fontSize: 28,
    color: colors.neutral900,
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
  },
  invoiceValue: {
    margin: 0,
    fontSize: 13,
    color: colors.neutral900,
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    fontWeight: 800,
    color: colors.neutral600,
    textTransform: 'uppercase',
    marginBottom: 8,
    marginTop: 0,
    fontSize: 12,
    whiteSpace: 'nowrap',
  },
  badge: {
    height: 18,
    borderRadius: 20,
    fontSize: 12,
    paddingLeft: 8,
    paddingRight: 8,
    position: 'relative',
    top: -4,
    whiteSpace: 'nowrap',
  },
  increment: {
    transform: 'rotate(90deg)',
    marginRight: 6,
    height: 14,
    width: 14,
    '& path': {
      fill: colors.success600,
    },
  },
  incrementNegative: {
    transform: 'rotate(-90deg)',
    '& path': {
      fill: colors.destructive600,
    },
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: colors.success,
    display: 'inline-block',
    marginRight: 4,
  },
  rating: {
    '& svg': {
      color: colors.warning500,
    },
    marginLeft: 8,
  },
  avatar: {
    display: 'flex',
    marginLeft: 16,
  },
  profileName: {
    fontWeight: 500,
    color: colors.neutral600,
    fontSize: 14,
    marginLeft: 9,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
});
